module.exports = __webpack_public_path__ + "static/media/logo-dark.64a3e991.png";